export class nscModel {
  "consumerId": string = "";
  "newUserName" : string = "";
  "newUserMob" : string = "";
  "mobileOtp" : string = "";
 
}


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/nsc/nsc.model.ts